/**
 * Static contract for the troubleshooting-agent Run panel: the defaults the form
 * opens on and the field state `buildVariables` reads.
 *
 * Pinned against the `ai-agents-hub` README (`troubleshooting-agent` section) on
 * 2026-09-02 — NOT inferred from the performance agent, whose envelope differs.
 * One input, the provider: `--project`, `--environment`,
 * `--activity-id` and `--src-dir` are locked to the runtime's own
 * `PLATFORM_PROJECT` / `PLATFORM_BRANCH`, the passed `ACTIVITY_ID` and the
 * auto-clone path, so there is no application picker and no timeframe.
 */

import { DEFAULT_PROVIDER } from "../agentEngine/config";

import type { Provider } from "../agentEngine/config";

/**
 * Task-type discriminator. `base: "troubleshooting-agent"` expands to a
 * `troubleshooting-agent:<major>:<build>` image type, so the prefix is stable
 * across the user-chosen task NAME (which can collide with a customer task).
 * Same prefix `agentReport.selectors` matches on for the Report tab.
 */
export const TROUBLESHOOTING_AGENT_TASK_TYPE_PREFIX = "troubleshooting-agent:";

export const isTroubleshootingAgentTask = (
  taskType: string | undefined
): boolean =>
  Boolean(taskType?.startsWith(TROUBLESHOOTING_AGENT_TASK_TYPE_PREFIX));

/** The form's field state — the shape `buildVariables` reads. */
export interface TroubleshootingAgentFormState {
  /** Provider alias → `MODEL`. */
  provider: Provider;
}

export const initialTroubleshootingAgentState =
  (): TroubleshootingAgentFormState => ({
    provider: DEFAULT_PROVIDER
  });
